/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Role_Rewards_BodyInputs */



/**
* | output |
* | --- |
* | "Hand out roles as members reach levels, and keep or replace the ones before." |
*
* @param {Features_Role_Rewards_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_role_rewards_body = /** @type {((inputs?: Features_Role_Rewards_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Role_Rewards_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выдавайте роли по мере того, как участники достигают уровней, и сохраняйте или заменяйте предыдущие.")
	return /** @type {LocalizedString} */ ("Hand out roles as members reach levels, and keep or replace the ones before.")
});